/**
 * The dashboard is hidden for now — in every environment. Flip this to true to bring it back.
 *
 * Every path that would take a user there — the /dashboard route, the post-login redirect,
 * the `/` redirect and the side-menu entry — reads these constants, so this is the only line
 * that needs to change.
 */
export const DASHBOARD_ENABLED: boolean = false;

/** The home screen — where /dashboard sends users while the dashboard is hidden. */
export const HOME_ROUTE = '/home';

/** Where the app lands after login and where `/` redirects. */
export const LANDING_ROUTE = DASHBOARD_ENABLED ? '/dashboard' : HOME_ROUTE;
